import React from 'react';
import { Eyebrow } from './Eyebrow';
export function ClosingWords() {
  return <section aria-labelledby="closing-heading" className="bg-night py-16 sm:py-24" data-id="element-43" data-mp="3mv324v3tukc0">
      <div className="mx-auto max-w-3xl px-5 text-center sm:px-6" data-id="element-44" data-mp="3mt0gsodmdfdm">
        <Eyebrow align="center" data-id="element-45" data-mp="3hu5moqa7c4e7">Final thoughts</Eyebrow>
        <h2 id="closing-heading" className="mt-5 font-display text-4xl leading-[0.95] sm:text-7xl" data-id="element-46" data-mp="3duoevq7ayv5v">
          <span className="block text-cream" data-id="element-47" data-mp="38vtx8rl2ncnc">Stop improvising.</span>
          <span className="block text-amber" data-id="element-48" data-mp="343tqogahxlhs">Start architecting.</span>
        </h2>
        <p className="mt-7 font-serif text-lg italic leading-relaxed text-cream-soft sm:text-xl" data-id="element-49" data-mp="2z58tyqugdjy3">
          You&rsquo;ve spent years mastering jazz guitar. You deserve a teaching system that matches
          your musicianship. Join 2,500+ educators who now plan their entire year in minutes.
        </p>
        <p className="mt-8 text-sm font-semibold uppercase tracking-label text-amber" data-id="element-50" data-mp="2l5px4u73dv13">
          Stop the chaos. Start the system.
        </p>
      </div>
    </section>;
}